export default __webpack_public_path__ + "static/69699910_963274540682334_7047241637895199562_n-4874ca94d1aaf39af6b89fb523302777.jpg";